export default __webpack_public_path__ + "static/media/featured_img.eed3f168.png";